// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wnCA","comment":"styles_comment__3szI_"};